import { ApiMethodIcon } from '@/components/api-method-icon/ApiMethodIcon';
import { CustomLink } from '@/components/custom-link/CustomLink';
import type {
  SidebarTreeCustomEndpointNode,
  SidebarTreeHttpApiNode,
  SidebarTreeWebSocketApiNode,
} from '@/shared/constant/sidebar-tree/SidebarTreeNode';
import { ApiStatusType } from '@tarslib/types/lib/httpApi';
import clsx from 'clsx';
import React from 'react';
import styles from '../../SidebarTree.module.css';
import { useSidebarTreeStore } from '../../store/sidebarTreeStore';
import { generateClassNameBySidebarTreeNodeKey } from '../../util/generateClassNameBySidebarTreeNodeKey';
import { StatusBadge } from '../status-badge/StatusBadge';

export type SidebarApiProps = {
  value: SidebarTreeHttpApiNode | SidebarTreeWebSocketApiNode | SidebarTreeCustomEndpointNode;
  isHidden: boolean;
};

export const SidebarApi = React.memo(function SidebarApiComponent(props: SidebarApiProps) {
  const { value, isHidden } = props;
  const { status, to, name } = value;

  const selected = useSidebarTreeStore((x) => x.selectedKey === value.key);
  const setSelectedKey = useSidebarTreeStore((x) => x.setSelectedKey);

  return (
    <li>
      <CustomLink
        className={clsx(styles['sidebar-tree-node'], {
          [`${styles['sidebar-tree-node--selected']}`]: selected,
          ['font-600']: selected,
          [generateClassNameBySidebarTreeNodeKey(value.key)]: selected,
        })}
        sampleName={name}
        isSampleLink={isHidden}
        to={to}
        title={name}
        onClick={() => {
          setSelectedKey(value.key);
        }}
      >
        <span
          className={clsx('break-word', {
            ['line-through']:
              status === ApiStatusType.deprecated || status === ApiStatusType.obsolete,
          })}
        >
          {name}
        </span>

        {status !== ApiStatusType.released && <StatusBadge status={status} />}

        <div className="flex-1" />

        <ApiMethodIcon value={value} className="ml-2 mt-1 max-w-[70px]" inverse={selected} />
      </CustomLink>
    </li>
  );
});
